import React from 'react';

import PropTypes from 'prop-types';

import { useLocale } from '@adsk/alloy-react-locale';
import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

export type NoAutocompleteResultsProps =
  StylableComponent<HTMLParagraphElement>;

const NoAutocompleteResults = ({
  className,
  style,
  children,
  ...props
}: NoAutocompleteResultsProps) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const text =
    React.Children.toArray(children).length > 0
      ? children
      : T.translate('NO_RESULTS');

  return (
    <p
      data-testid="Dropdown__noResults"
      className={className}
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 0,
          height: 32,
          color: theme.tokens.colors.text.secondary.value,
        },
        theme.typography.bodySmall,
        style,
      ]}
      {...props}
    >
      {text}
    </p>
  );
};

NoAutocompleteResults.displayName = 'NoAutocompleteResults';

NoAutocompleteResults.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Override for no results content */
  children: PropTypes.any,
};

export default NoAutocompleteResults;
